import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../context/ConfigContext';
import { Category, Restaurant } from '../../../interfaces/Catalogue';
import { GenericCardList } from '../../common/GenericCardList/GenericCardList';
import RestaurantLoader from '../../common/RestaurantLoader/RestaurantLoader.';
import SectionHeader from '../ArticlesDiscountSection/SectionHeader/SectionHeader';
import { CategoryCard } from './CategoryCard/CategoryCard';
import './CategoryList.scss';

interface CategoryListProps {
  categories?: Category[];
  loading?: boolean;
}

const CategoryList: React.FC<CategoryListProps> = ({
  categories = [],
  loading = false,
}) => {
  const isPhone = window.innerWidth <= 768;
  const scrollDirection = isPhone ? 'horizontal' : 'vertical';
  const itemSpacing = isPhone ? 12 : 35;
  const { config } = useConfig();
  const navigate = useNavigate();
  const mode: number = useSelector((state: any) => state.menu.mode);
  const selectedRestaurant: Restaurant = useSelector((state: any) => state.shop.selectedRestaurant);

  // Filter visible categories and sort by orderIndex
  const [visibleCategories, setVisibleCategories] = useState<Category[]>([]);

  useEffect(() => {
    const filtered = categories
      .filter(category => category.visible
        // && category.typeOrderFamily.some((typeOrder: TypeOrderFamily) => typeOrder.type === mode)
      )
      .sort((a, b) => a.orderIndex - b.orderIndex);
    setVisibleCategories(filtered);
  }, [categories, mode]);

  const handleCategoryPress = (category: Category) => {
    // navigate(`${selectedRestaurant.id}/category/${category.id}`, { state: { category } });
    navigate(`restaurant/${selectedRestaurant?.id}`, { state: { selectedCategory: category } });
  };

  const renderCategoryCard = (category: Category, onPress?: (item: Category) => void) => (
    <CategoryCard
      category={category}
      onPress={() => onPress?.(category)}
      itemsPerRow={ isPhone ? 3 : 4 }
    />
  );

  const handleViewAllPress = () => {
    navigate(`restaurant/${selectedRestaurant.id}`);
  };

  const LoadingComponent = () => (
    <RestaurantLoader
      message="Chargement des catégories..."
      size="medium"
      variant="spinner"
    />
  );

  const EmptyComponent = () => (
    <div className="empty-container">
      <div className="empty-content">
        <div className="empty-icon-container">
          <div className="empty-icon">🍽️</div>
        </div>
        <div className="empty-title">Aucune catégorie disponible</div>
        <div className="empty-subtitle">
          Nos chefs préparent de nouvelles catégories pour vous !
        </div>
      </div>
    </div>
  );

  const HeaderComponent = () => (
    <SectionHeader
      title="Explorez la carte"
      iconName="restaurant"
      onPressSeeAll={handleViewAllPress}
      showSeeAll
    />
  );

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="category-list-container">
      <HeaderComponent />
      <GenericCardList
        data={isPhone ? visibleCategories.slice(0, 5) : visibleCategories}
        renderCard={renderCategoryCard}
        onCardPress={handleCategoryPress}
        keyExtractor={(item) => item.id.toString()}
        scrollDirection={scrollDirection}
        containerPadding={4}
        itemSpacing={itemSpacing}
        showHorizontalScrollIndicator={false}
        ListEmptyComponent={<EmptyComponent />}
        contentContainerStyle={{ paddingBottom: 4 }}
        showViewAll={true}
        onPressViewAll={handleViewAllPress}
        itemsPerRow={ isPhone ? 2 : 4 }
      />
    </div>
  );
};

export default CategoryList;